import { ChangeDetectionStrategy, ChangeDetectorRef, Component, inject, PLATFORM_ID } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BehaviorSubject, Observable, Subject, Subscription } from 'rxjs';
import { SoftwareSpecificSearchService } from '../software-specific-search.service';
import { AbstractControl, FormControl, FormGroup, Validators } from '@angular/forms';
import {
  AuthService,
  GlobalMessageService,
  GlobalMessageType,
  isNotNullable,
  OccEndpointsService,
  TranslationService,
} from '@spartacus/core';
import { distinctUntilChanged, filter, takeUntil } from 'rxjs/operators';
import { MatDialog } from '@angular/material/dialog';
import { WebshopPopupComponent } from './webshop-popup/webshop-popup.component';
import { PrivacyTermsPopUpComponent } from './privacy-terms-pop-up/privacy-terms-pop-up.component';
import { KBLanguageService } from 'src/app/services/sapSpartacus/kb-lang.service';
import { CountryService } from '../../site-context-selector/country.service';
import { BsLocaleService } from 'ngx-bootstrap/datepicker';
import { KbCaptchaService } from 'src/app/services/feature/kb-captcha/kb-captcha.service';
import { isPlatformBrowser } from '@angular/common';
const commonTradingPartners: [string, string][] = [
  ['WORKSHOP_ALL_TRUCKS', 'Alltrucks Workshop'],
  ['EXPERT_NETWORK_WORKSHOP', 'Expert Network Workshop'],
  ['FLEET', 'Fleet'],
  ['OTHER', 'Other'],
  ['PUBLIC_SERVICES', 'Public Services'],
  ['WORKSHOP_OR_SERVICE_CENTRE', 'Workshop'],
];

const eacsEOLTradingPartners: [string, string][] = [
  ['DISTRIBUTOR', 'Distributor'],
  ['EXPERT_NETWORK_WORKSHOP', 'Expert Network Workshop'],
  ['OTHER', 'Other'],
  ['PUBLIC_SERVICES', 'Public Services'],
  ['WORKSHOP_OR_SERVICE_CENTRE', 'Workshop'],
];

// Create maps using the arrays
const tebsTradingPartner = new Map(commonTradingPartners);
const neoTradingPartner = new Map(commonTradingPartners);
const ECUTEBS4TradingPartner = new Map(commonTradingPartners);
const ECUTRMTradingPartner = new Map(commonTradingPartners);
const EACSEOLTradingPartner = new Map(eacsEOLTradingPartners);
@Component({
  selector: 'app-soft-ware-request-form-page',
  templateUrl: './soft-ware-request-form-page.component.html',
  styleUrls: ['./soft-ware-request-form-page.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class SoftWareRequestFormPageComponent {
  private service = inject(SoftwareSpecificSearchService);
  private activatedroute = inject(ActivatedRoute);
  private cdr = inject(ChangeDetectorRef);
  private authService = inject(AuthService);
  private matdialog = inject(MatDialog);
  private endPointService = inject(OccEndpointsService);
  private translationservice = inject(TranslationService);
  private router = inject(Router);
  private globalMessageService = inject(GlobalMessageService);
  public countryService = inject(CountryService);
  public langService = inject(KBLanguageService);
  private localeService = inject(BsLocaleService);
  private captchaService = inject(KbCaptchaService);
  platformId = inject(PLATFORM_ID);
  private unsubscribe$ = new Subject<void>();
  subscription = new Subscription();
  baseUrl: string = this.endPointService.getBaseUrl({
    baseUrl: true,
    prefix: false,
    baseSite: false,
  });
  bsConfig = { dateInputFormat: 'DD.MM.YYYY', showWeekNumbers: false, displayOneMonthRange: true };
  fileData = new FormData();
  apiData$: Observable<any>;
  CanLoadPage$ = new BehaviorSubject<boolean>(false);
  apiResponse: any;
  pricekey: string = 'common.text_software_request_form_pin_price';
  pricestringValue = '';
  topradioButtonState: string = 'softwareOnly';
  fileName: string = undefined;
  showModel: boolean = true;
  softWareTypeCode: string;
  softWareCode: string;
  isUserLoggedIn: boolean = false;
  isUserEdited: boolean = false;
  apiPayLoad;
  isNeo: boolean = false;
  isradioButtonrequired: boolean = true;
  canShowTradingPartner: boolean = false;
  isFormContainsError: boolean = false;
  isTradingPartnerIsInputBox: boolean = true;
  tradingPartnerDropdown: any;
  bsConfigFormat: string = '';
  today: Date;
  //License
  isreview: boolean = false;
  hideChoiceNote: boolean = true;
  isRecaptchaDone: boolean = false;
  currentLang: string = 'EN_GB';
  /*  industrySelected = null;
   countrySelected = null; */

  isSubmitDisabled = true;

  //captcha
  imageUrl: string;
  challengeExpiry: string;
  captchaInput: string;
  response: any;
  status: any;
  captchaInvalid: boolean = false;
  captchaExpired: boolean = false;
  captchaEmpty: boolean = false;
  kbCaptchaForChina: boolean = false;




  topradio = [
    {
      key: 'softwareandpin',
      translationKey: 'common.text_software_request_form_choice_one_lable',
    },
    {
      key: 'softwarerenewal',
      translationKey: 'common.text_software_request_form_choice_three_lable',
    },
    {
      key: 'softwareOnly',
      translationKey: 'common.text_software_request_form_choice_two_lable',
    },
  ];
  softWaTypedata = [
    { code: 'ABS8', name: 'ABS8 EOL Diagnostic' },
    { code: 'DAS', name: 'DAS EOL Diagnostic' },
    { code: 'EACS_EOL_Diagnostics', name: 'EACS EOL Diagnostics' },
    { code: 'EBS5', name: 'EBS5 EOL Diagnostic' },
    { code: 'A18', name: 'ECUtalk® A18' },
    { code: 'KB4TA', name: 'ECUtalk® KB4TA' },
    { code: 'TEBS4', name: 'ECUtalk® TEBS4' },
    { code: 'TEBSG2', name: 'ECUtalk® TEBSG2' },
    { code: 'TIMG2', name: 'ECUtalk® TIMG2' },
    { code: 'TPMS', name: 'ECUtalk® TPMS' },
    { code: 'TRM', name: 'ECUtalk® TRM' },
    { code: 'ELC5', name: 'ELC5 EOL Diagnostic' },
    { code: 'EPB', name: 'EPB EOL Diagnostic' },
    { code: 'IAPU', name: 'IAPU EOL Diagnostic' },
    { code: 'JALTEST', name: 'Jaltest Link RP1210' },
    { code: 'NEO', name: 'NEO' },
    { code: 'PROFLEET_ASSIST', name: 'ProFleet Assist' },
    { code: 'PROFLEET_ASSIST_G2', name: 'ProFleet Assist Gen 2' },
    { code: 'iTPMS', name: 'iTPMS Application' },
  ];

  companyInfo = new FormGroup({
    companyName: new FormControl(null, { validators: Validators.required }),
    role: new FormControl(null, { validators: Validators.required }),
    firstName: new FormControl(null, { validators: Validators.required }),
    lastName: new FormControl(null, { validators: Validators.required }),
    address: new FormControl(null, { validators: Validators.required }),
    city: new FormControl(null, { validators: Validators.required }),
    country: new FormControl(null, { validators: Validators.required }),
    postalCode: new FormControl(null, { validators: Validators.required }),
    phone: new FormControl(null,
      [
        Validators.required,
        Validators.pattern('^[0-9]+$')
      ]
    ),
    email: new FormControl(null, [Validators.email, Validators.required]),
    tradingPartner: new FormControl(null, { validators: Validators.required }),
    department: new FormControl(null),
    address2: new FormControl(null),
  });
  trainingInfo = new FormGroup({
    trainedpersonfirstname: new FormControl(null, { validators: Validators.required }),
    trainedpersonlastname: new FormControl(null, { validators: Validators.required }),
    trainedpersonstillAtCompany: new FormControl('false', { validators: Validators.required }),
    placeofTraining: new FormControl('', { validators: Validators.required }),
    trainerName: new FormControl(null, { validators: Validators.required }),
    dateofTraining: new FormControl(null, { validators: Validators.required }),
    elearningCompleted: new FormControl('false'),
  });
  quantityOfLicense = new FormGroup({
    quantity: new FormControl(null, { validators: Validators.required }),
  });
  captchaSection = new FormGroup({
    privacyTermsCheckBox: new FormControl(false),
    webShopCheckBox: new FormControl(false),
    licenseCheckBox: new FormControl(false),
    recaptcha: new FormControl(null, { validators: Validators.required }),
  });
  localizedDateFormat: any;
  timeout: any;
  get company() {
    return this.companyInfo.controls;
  }
  get training() {
    return this.trainingInfo.controls;
  }
  ngOnInit() {
    // Fetch the initial captcha
    this.captchaService.fetchCaptcha();

    this.subscription?.add(this.captchaService.imageUrl$.subscribe((url) => {
      this.imageUrl = url;
      this.cdr.detectChanges();
    }));

    this.subscription?.add(this.captchaService.challengeExpiry$.subscribe((expiry) => {
      this.challengeExpiry = expiry;
      this.cdr.detectChanges();
    }));
    this.subscription?.add(this.langService.getActive().subscribe((lang) => {
      this.localeService.use(lang);
      if (this.softWareCode) {
        this.apiData$ = this.service.getSoftwareFormPage(this.softWareCode);
        this.subscription?.add(this.apiData$.subscribe((res: any) => {
          this.apiResponse = res;
          this.bsConfigFormat = this.apiResponse?.dateFormat?.toUpperCase();
          this.localizedDateFormat =
            res?.localizedDateFormat && res.localizedDateFormat.trim() !== ''
              ? res.localizedDateFormat
              : this.bsConfigFormat;
          if (this.localizedDateFormat.includes('common')) {
            this.subscription?.add(this.translationservice.translate(this.localizedDateFormat).subscribe((res) => {
              this.localizedDateFormat = res;
            }));
          }
          this.cdr.detectChanges();
        }));
        this.pageLoadstateChanges();
      }
    }));

    this.today = new Date();
    this.topradioButtonState = 'softwareOnly';
    this.trainingInfo.disable();
    this.quantityOfLicense.disable();
    this.companyInfo.controls.tradingPartner.disable();

    this.subscription?.add(this.activatedroute.queryParamMap.subscribe((params) => {
      const code = params.get('code');
      if (isPlatformBrowser(this.platformId)) {
        if (code) {
          sessionStorage.setItem('softwareCode', code);
          this.softWareCode = code;
        } else {
          const savedCode = sessionStorage.getItem('softwareCode');
          if (savedCode) {
            this.softWareCode = savedCode;
            const url = this.router.createUrlTree([], {
              relativeTo: this.activatedroute,
              queryParams: { code: savedCode },
              queryParamsHandling: 'merge',
            }).toString();

            window.history.replaceState({}, '', url);
          }

        }
      }

      this.apiData$ = this.service.getSoftwareFormPage(this.softWareCode);
      this.pageLoadstateChanges();
    }));
    this.subscription?.add(this.trainingInfo.controls.elearningCompleted.valueChanges.subscribe((res: string) => {
      if (res == 'false') {
        this.trainingInfo.controls.placeofTraining.enable();
        this.trainingInfo.controls.trainerName.enable();
      } else {
        this.trainingInfo.controls.placeofTraining.disable();
        this.trainingInfo.controls.trainerName.disable();
      }
    }));

    this.subscription?.add(this.quantityOfLicense.controls.quantity.valueChanges.subscribe((res: any) => {
      if (res && (res == 0 || res > 9)) {
        const number = res == 0 ? 1 : res?.toString().slice(0, 1);
        this.quantityOfLicense.controls.quantity.setValue(number);
      }
    }));

    this.subscription?.add(this.companyInfo.statusChanges.subscribe(() => {
      this.checkFormStatus();
    }));
    this.subscription?.add(this.trainingInfo.statusChanges.subscribe(() => {
      this.checkFormStatus();
    }));

  }

  ngAfterViewInit() {
    this.tradingPartnerDynamiChanges();
    this.roleIndustryDynamiChanges();
  }

  checkFormStatus() {
    this.isSubmitDisabled = true; // Disable the submit button on any change
  }

  convertTranslatedStringFromKey(key: string, price) {
    this.subscription?.add(this.translationservice.translate(key).subscribe((res: string) => {
      this.pricestringValue = res.replace('{0}', price);
    }));
  }

  /*   tradingPartnerDynamiChanges() {
      this.companyInfo.controls.country.valueChanges
        .pipe(takeUntil(this.unsubscribe$), filter(isNotNullable))
        .subscribe((value: any) => {
          this.updateDropdownOfTradingPartner(value);
        });
    } */
  tradingPartnerEdit(event: any) {
    const country = this.company.country.value;
    const role = this.company.role.value;
    if (country == 'CN') {
      this.kbCaptchaForChina = true;
    } else {
      this.kbCaptchaForChina = false;
    }
    if (country && role) {
      const industry = this.getFilteredIndustry(this.softWareTypeCode, role);

      if (industry) {

        if (this.tradingPartnerDropdown.length > 0) {
          this.isTradingPartnerIsInputBox = false;
        } else {
          this.isTradingPartnerIsInputBox = true;
        }
        this.canShowTradingPartner = true;
        this.companyInfo.controls.tradingPartner.enable();
      } else {
        this.canShowTradingPartner = false;
        this.companyInfo.controls.tradingPartner.disable;
      }
    }
  }
  private getFilteredIndustry(
    softCode: string,
    industryCode: string | null
  ): string | null {
    if (!industryCode) {
      return null;
    }

    switch (softCode) {
      case 'TEBSG2':
        return this.topradioButtonState !== 'softwareOnly'
          ? tebsTradingPartner.get(industryCode) ?? null
          : null;

      case 'NEO':
        return neoTradingPartner.get(industryCode) ?? null;

      case 'EACS_EOL_Diagnostics':
        return this.topradioButtonState !== 'softwareOnly'
          ? EACSEOLTradingPartner.get(industryCode) ?? null
          : null;

      case 'TEBS4':
        return this.topradioButtonState !== 'softwareOnly'
          ? ECUTEBS4TradingPartner.get(industryCode) ?? null
          : null;

      case 'TRM':
        return this.topradioButtonState !== 'softwareOnly'
          ? ECUTRMTradingPartner.get(industryCode) ?? null
          : null;

      default:
        return null;
    }
  }


  roleValueChanges(value: string) {
    // const hiddenValues = new Set([
    //   'DISTRIBUTOR',
    //   'MANUFACTURER_ENGINEERING',
    //   'MANUFACTURER_PRODUCTION',
    //   'MANUFACTURER_WORKSHOP',
    //   'TRAILER_MANUFACTURER',
    //   'Truck_Manufacturer',
    //   'EXPERT_NETWORK_WORKSHOP',
    //   'FLEET',
    //   'OTHER',
    //   'PUBLIC_SERVICES',
    //   'WORKSHOP_OR_SERVICE_CENTRE',
    // ]);
    // const control = this.companyInfo.controls.tradingPartner;
    // if (this.softWareTypeCode !== 'NEO') {
    //   // this.canShowTradingPartner = !hiddenValues.has(value);
    //   // this.canShowTradingPartner ? control.enable() : control.disable();
    // }
    // this.cdr.detectChanges();
  }

  pageLoadstateChanges() {
    this.subscription?.add(this.authService
      .isUserLoggedIn()
      .pipe(distinctUntilChanged())
      .subscribe((res: boolean) => {
        this.isUserLoggedIn = res;
        this.subscription?.add(this.apiData$.subscribe((res: any) => {
          this.apiResponse = res;
          this.bsConfigFormat = this.apiResponse.dateFormat.toUpperCase();
          this.localizedDateFormat =
            res?.localizedDateFormat && res.localizedDateFormat.trim() !== ''
              ? res.localizedDateFormat
              : this.bsConfigFormat;
          if (this.localizedDateFormat.includes('common')) {
            this.subscription?.add(this.translationservice.translate(this.localizedDateFormat).subscribe((res) => {
              this.localizedDateFormat = res;
            }));
          }
          console.log('localizedDateFormat', this.localizedDateFormat);
          this.convertTranslatedStringFromKey(
            this.pricekey,
            res.softwarePackageInfo?.softwarePinRenewalPrice ?? res.softwarePackageInfo?.softwarePrice
          );
          if (this.isUserLoggedIn) {
            this.prePopulateFormData(res?.companyInfo);
            this.disableFieldsforLoggedInUser();
          }
          this.softWareTypeCode = res?.softwarePackageInfo?.softwareType;
          this.showModel = this.topradioButtonState == 'softwareOnly' ? false : true;
          if (
            this.softWareTypeCode == 'ABS8' ||
            this.softWareTypeCode == 'DAS' ||
            this.softWareTypeCode == 'EBS5' ||
            this.softWareTypeCode == 'ELC5' ||
            this.softWareTypeCode == 'EPB' ||
            this.softWareTypeCode == 'IAPU'
          ) {
            this.hideChoiceNote = false;
            this.showModel = false;
          }
          if (this.softWareTypeCode == 'NEO') {
            this.isNeo = true;
            this.isTradingPartnerIsInputBox = false;
            this.quantityOfLicense.enable();
            this.topradio = this.topradio.filter((obj) => !(obj.key == 'softwarerenewal'));
            this.topradio = this.topradio.filter((obj) => !(obj.key == 'softwareOnly'));
            this.topradioButtonState = 'softwareandpin';
            this.showModel = true;
            this.convertTranslatedStringFromKey(this.pricekey, this.apiResponse?.softwarePackageInfo?.softwarePrice);
          } else if (
            this.softWareTypeCode == 'TRM' ||
            this.softWareTypeCode == 'TEBS4' ||
            this.softWareTypeCode == 'EACS_EOL_Diagnostics'
          ) {
            // if (this.softWareTypeCode == 'TEBS4' || this.softWareTypeCode == 'EACS_EOL_Diagnostics') {
            //   this.trainingInfo.controls.elearningCompleted.disable();
            // }
            this.topradio = this.topradio.filter((obj) => !(obj.key == 'softwarerenewal'));
          } else if (this.softWareTypeCode == 'TEBSG2') {
          } else {
            this.isradioButtonrequired = false;
            this.topradioButtonState = '';
          }
          this.CanLoadPage$.next(true);
          this.cdr.detectChanges();
        }));
      }));
  }
  prePopulateFormData(res) {
    this.companyInfo.controls.companyName.setValue(res?.company);
    this.companyInfo.controls.email.setValue(res?.email);
    this.companyInfo.controls.address.setValue(res?.streetName);
    // this.companyInfo.controls.address2.setValue(res?.line2);
    this.companyInfo.controls.phone.setValue(res?.phone);
    this.companyInfo.controls.postalCode.setValue(res?.postalcode);
    this.timeout = setTimeout(() => {
      this.companyInfo.controls.country.setValue(res?.country);
      this.companyInfo.controls.role.setValue(null);
    }, 1000);
    this.companyInfo.controls.city.setValue(res?.town);
    // this.companyInfo.controls.department.setValue(res?.department);
    this.companyInfo.controls.firstName.setValue(res?.firstName);
    this.companyInfo.controls.lastName.setValue(res?.lastName);
    // this.companyInfo.controls.tradingPartner.setValue(res?.tradingPartner);
  }
  topradioButtonStateChanges(itemCode: string): void {
    this.topradioButtonState = itemCode;
    const country = this.company.country.value;
    const role = this.company.role.value;
    const industry = this.getFilteredIndustry(this.softWareTypeCode, role);
    this.showModel = itemCode !== 'softwareOnly';

    const isSoftwareWithPinOrRenewal = itemCode === 'softwarerenewal' || itemCode === 'softwareandpin';
    const hasCountryAndIndustry = country && role;

    if (isSoftwareWithPinOrRenewal && hasCountryAndIndustry && industry) {
      this.canShowTradingPartner = true;
      this.company.tradingPartner.enable();
    } else {
      this.canShowTradingPartner = false;
      this.company.tradingPartner.disable();
    }

    if (itemCode === 'softwareOnly') {
      this.canShowTradingPartner = false;
      this.trainingInfo.disable({ emitEvent: false });
      this.trainingInfo.clearValidators();
      this.trainingInfo.updateValueAndValidity({ emitEvent: false });
      this.cdr.detectChanges();
    } else if (this.softWareTypeCode !== 'NEO') {
      this.trainingInfo.enable();
      this.cdr.detectChanges();
    }
    if (this.softWareTypeCode === 'TEBSG2') {
      if (itemCode === 'softwareandpin') {
        this.canShowTradingPartner = true;
        this.convertTranslatedStringFromKey(this.pricekey, this.apiResponse?.softwarePackageInfo?.softwarePrice);
      } else if (itemCode === 'softwarerenewal') {
        this.convertTranslatedStringFromKey(this.pricekey, this.apiResponse?.softwarePackageInfo?.softwarePinRenewalPrice);
      }
    }

    if (['TEBS4', 'EACS_EOL_Diagnostics'].includes(this.softWareTypeCode)) {
      this.trainingInfo.controls.elearningCompleted.disable();
    }

    this.disableFieldsforLoggedInUser();
    this.company.role.reset(null, {
      emitEvent: false
    });

    this.company.role.markAsUntouched();
    this.company.role.markAsPristine();
    this.company.role.updateValueAndValidity({ emitEvent: false });
    this.cdr.detectChanges();


    this.showModel = itemCode !== 'softwareOnly';



    if (['TEBS4', 'EACS_EOL_Diagnostics'].includes(this.softWareTypeCode)) {
      this.trainingInfo.controls.elearningCompleted.disable({ emitEvent: false });
    }

    this.disableFieldsforLoggedInUser();
    this.cdr.detectChanges();
  }


  disableFieldsforLoggedInUser(): void {
    if (!this.isUserLoggedIn) {
      return;
    }
    const controls = this.companyInfo.controls;
    const disableFields = ['companyName', 'firstName', 'lastName', 'department', 'address', 'address2', 'city', 'postalCode', 'email'];
    const enableFields = ['country'];

    const shouldDisableFields = this.shouldDisableFieldsForSoftwareType();

    if (shouldDisableFields) {
      this.setFieldState(disableFields, controls, false);
    } else {
      this.setFieldState(enableFields, controls, true);
    }

    const shouldEnableTradingPartner = this.shouldEnableTradingPartner();
    this.setTradingPartnerState(shouldEnableTradingPartner);
  }

  private shouldDisableFieldsForSoftwareType(): boolean {
    const isSoftwareWithPinOrRenewal = ['softwareandpin', 'softwarerenewal'].includes(this.topradioButtonState);
    const isNotNEO = this.softWareTypeCode !== 'NEO';
    return isNotNEO && isSoftwareWithPinOrRenewal;
  }

  private shouldEnableTradingPartner(): boolean {
    const country = this.company.country.value;
    const role = this.company.role.value;
    if (!country || !role) {
      //If either country or role is not selected → trading partner cannot be enabled  const country 
      return false;
    }
    const industry = this.getFilteredIndustry(this.softWareTypeCode, role);

    // No industry mapping → no trading partner
    if (!industry) {
      return false;
    }

    // Decide input vs dropdown
    this.isTradingPartnerIsInputBox =
      !this.tradingPartnerDropdown || this.tradingPartnerDropdown.length === 0;

    // Final visibility condition
    return (
      this.canShowTradingPartner &&
      (this.isTradingPartnerIsInputBox || this.tradingPartnerDropdown.length > 0)
    );
  }




  tradingPartnerDynamiChanges(): void {
    this.company.country.valueChanges
      .pipe(takeUntil(this.unsubscribe$), filter(isNotNullable))
      .subscribe((country: string) => {
        this.kbCaptchaForChina = country === 'CN';
        this.updateDropdownOfTradingPartner(country);
        this.evaluateTradingPartnerVisibility();
      });
  }
  roleIndustryDynamiChanges(): void {
    this.company.role.valueChanges
      .pipe(takeUntil(this.unsubscribe$), filter(isNotNullable))
      .subscribe(() => {
        this.evaluateTradingPartnerVisibility();
      });
  }
  updateDropdownOfTradingPartner(country: string): void {
    const match = this.apiResponse?.tradingPartnerMapNew?.find(
      (item) => item?.key?.isocode === country
    );

    this.tradingPartnerDropdown = match?.value?.tradingPartnerList ?? [];
    this.isTradingPartnerIsInputBox = this.tradingPartnerDropdown.length === 0;

    this.company.tradingPartner.reset(null, { emitEvent: false });
  }

  private setFieldState(fields: string[], controls: any, enable: boolean) {
    fields.forEach(field => enable ? controls[field].enable() : controls[field].disable());
  }

  private setTradingPartnerState(enable: boolean) {
    const controls = this.companyInfo.controls;
    enable ? controls.tradingPartner.enable() : controls.tradingPartner.disable();
    this.canShowTradingPartner = enable;
  }



  makeFormEditable() {
    this.isUserEdited = true;
    this.companyInfo.controls.companyName.enable();
    this.companyInfo.controls.firstName.enable();
    this.companyInfo.controls.lastName.enable();
    this.companyInfo.controls.department.enable();
    this.companyInfo.controls.address.enable();
    this.companyInfo.controls.address2.enable();
    this.companyInfo.controls.city.enable();
    this.companyInfo.controls.postalCode.enable();
    this.companyInfo.controls.email.enable();
    // this.companyInfo.controls.tradingPartner.enable();
    // this.canShowTradingPartner = true;
    // this.isTradingPartnerIsInputBox = false;
  }

  onFileSelected(event: any): void {
    const selectedFile = event.files[0];
    if (selectedFile) {
      this.fileData.append('attachment', selectedFile);
      this.fileName = selectedFile.name;
      event.value = '';
    }
    this.cdr.detectChanges();
  }

  canSubmit() {
    this.refreshCaptcha();
    this.submitCaptcha();

    this.isFormContainsError = this.companyInfo.status === 'INVALID' || this.trainingInfo.status === 'INVALID';

    const companyValid = this.companyInfo.valid;
    const trainingValid = this.trainingInfo.valid;
    const quantityValid = this.quantityOfLicense.valid;
    const trainingDisabled = this.trainingInfo.disabled;
    const quantityDisabled = this.quantityOfLicense.disabled;
    const trainedPersonStillAtCompany = this.trainingInfo.controls.trainedpersonstillAtCompany.value === 'true';

    if (!companyValid) {
      this.companyInfo.markAllAsTouched();
      return this.cdr.detectChanges();
    }

    if (trainingDisabled && quantityDisabled) {
      return this.setReviewStateAndDetect(true);
    }

    if (trainingDisabled && !quantityDisabled) {
      return quantityValid
        ? this.setReviewStateAndDetect(true)
        : this.markAndDetect(this.quantityOfLicense);
    }

    if (!trainingDisabled && quantityDisabled) {
      return this.validateTrainingAndDetect(trainingValid, trainedPersonStillAtCompany);
    }

    if (trainingValid && quantityValid) {
      return this.validateTrainingAndDetect(trainingValid, trainedPersonStillAtCompany);
    }

    this.trainingInfo.markAllAsTouched();
    this.quantityOfLicense.markAllAsTouched();
    this.cdr.detectChanges();
  }

  private setReviewStateAndDetect(enabled: boolean) {
    this.isreview = enabled;
    this.isSubmitDisabled = !enabled;
    this.cdr.detectChanges();
  }

  private markAndDetect(control: AbstractControl) {
    control.markAllAsTouched();
    this.cdr.detectChanges();
  }


  private validateTrainingAndDetect(trainingValid: boolean, trainedPersonStillAtCompany: boolean) {
    if (trainingValid && trainedPersonStillAtCompany) {
      this.setReviewStateAndDetect(true);
    } else {
      this.globalMessageService.add({ key: 'common.form_global_error' }, GlobalMessageType.MSG_TYPE_ERROR);
      this.trainingInfo.markAllAsTouched();
      this.cdr.detectChanges();
    }
  }


  onSubmit() {
    this.apiPayLoad = this.payLoadCreator();
    this.postApiCall();
  }

  payLoadCreator() {
    this.trainingInfo.enable();
    this.quantityOfLicense.enable();
    const trainingDate = new Date(this.trainingInfo.controls.dateofTraining.value);
    const year = trainingDate.getFullYear();
    const month = ('0' + (trainingDate.getMonth() + 1)).slice(-2);
    const day = ('0' + trainingDate.getDate()).slice(-2);
    console.log(this.companyInfo.controls.phone.value);
    return {
      softwareCode: this.softWareCode,
      softwareType: this.softWareTypeCode,
      tariningCertificatePDF: this.fileData,
      //companyInFo
      companyName: this.companyInfo.controls.companyName.value ?? '',
      roleInIndustry: this.companyInfo.controls.role.value ?? '',
      firstName: this.companyInfo.controls.firstName.value ?? '',
      lastName: this.companyInfo.controls.lastName.value ?? '',
      address: this.companyInfo.controls.address.value ?? '',
      city: this.companyInfo.controls.city.value ?? '',
      country: this.companyInfo.controls.country.value ?? '',
      postalCode: this.companyInfo.controls.postalCode.value ?? '',
      phone: this.companyInfo.controls.phone.value ?? '',
      emailID: this.companyInfo.controls.email.value ?? '',
      tradingPartner: this.companyInfo.controls.tradingPartner.value ?? '',
      department: this.companyInfo.controls.department.value ?? '',
      adress2: this.companyInfo.controls.address2.value ?? '',
      //training INFO
      trainedPersonFirstName: this.trainingInfo.controls.trainedpersonfirstname.value ?? '',
      trainedPersonLastName: this.trainingInfo.controls.trainedpersonlastname.value ?? '',
      trainedPersonStillAtCompany:
        this.trainingInfo.controls.trainedpersonstillAtCompany.value == 'true' ? true : false,
      trainingPlace: this.trainingInfo.controls.placeofTraining.value ?? '',
      trainnerName: this.trainingInfo.controls.trainerName.value ?? '',
      trainingDate: this.trainingInfo.controls.trainedpersonfirstname.value ? `${day + '/' + month + '/' + year}` : '',
      softwareTrainingDate: this.trainingInfo.controls.trainedpersonfirstname.value
        ? `${year + '-' + month + '-' + day}`
        : '',
      eLearningCourseCompleted: this.trainingInfo.controls.elearningCompleted.value == 'true' ? true : false,
      //softWare And Pin
      softwareOnly: this.topradioButtonState == 'softwareOnly' ? true : false,
      softwareAndPin: this.topradioButtonState == 'softwareandpin' ? true : false,
      softwareAndPi: this.topradioButtonState == 'softwarerenewal' ? true : false,
      //isEditable
      Edit: this.isUserEdited,
      //IsNEO
      quantity: this.quantityOfLicense.controls.quantity.value,
      //captcha
      captchaCode: this.captchaSection.controls.recaptcha.value ?? '',
      nodata: '',
      //not filled
      isTrainingInfoRequired: this.trainingInfo.controls.trainedpersonfirstname.value ? true : false,
      termsCheck: false,
      trainingInfoRequired: this.trainingInfo.controls.trainedpersonfirstname.value ? true : false,
      updateNotification: false,
    };
  }

  postApiCall() {
    let PayLoadString;
    if (this.softWareTypeCode == 'NEO') {
      PayLoadString = `softwareLibrary/softwareRequest?softwareCode=${this.apiPayLoad.softwareCode}&company=${this.apiPayLoad.nodata
        }&firstName=${this.apiPayLoad.firstName}&lastName=${this.apiPayLoad.lastName}&postalCode=${this.apiPayLoad.postalCode
        }&country=${this.apiPayLoad.country}&emailID=${this.apiPayLoad.emailID}&isTrainingInfoRequired=${this.apiPayLoad.isTrainingInfoRequired
        }&softwareAndPi=${this.apiPayLoad.softwareAndPin}&softwareOnly=${this.apiPayLoad.softwareOnly}&pinRenewal=${this.apiPayLoad.softwareAndPi
        }&companyName=${this.apiPayLoad.companyName}&roleInIndustry=${this.apiPayLoad.roleInIndustry}&department=${this.apiPayLoad.department
        }&address=${this.apiPayLoad.address}&adress2=${this.apiPayLoad.adress2}&city=${this.apiPayLoad.city}&phone=${this.apiPayLoad.phone
        }&tradingPartner=${encodeURIComponent(this.apiPayLoad.tradingPartner)}&customTradingPartner=${this.apiPayLoad.nodata
        }&trainedPersonFirstName=${this.apiPayLoad.trainedPersonFirstName}&trainedPersonLastName=${this.apiPayLoad.trainedPersonLastName
        }&trainedPersonStillAtCompany=${this.apiPayLoad.trainedPersonStillAtCompany}&trainnerName=${this.apiPayLoad.trainnerName
        }&trainingDate=${this.apiPayLoad.trainingDate}&softwareTrainingDate=${this.apiPayLoad.softwareTrainingDate
        }&trainingPlace=${this.apiPayLoad.trainingPlace}&termsCheck=${this.apiPayLoad.termsCheck}&softwarePackageCode=${this.apiResponse.softwarePackageCode
        }&trainingInfoRequired=${this.apiPayLoad.trainingInfoRequired}&updateNotification=${this.apiPayLoad.updateNotification
        }&tradingPartnerFlag=${this.apiPayLoad?.tradingPartner ? true : ''}&softwareType=${this.apiPayLoad.softwareType
        }&captchaCode=${this.apiPayLoad.captchaCode}&Edit=${this.apiPayLoad.Edit}&softwareAndPin=${this.apiPayLoad.softwareAndPin
        }&quantity=${this.apiPayLoad.quantity}&eLearningCourseCompleted=${this.apiPayLoad.eLearningCourseCompleted}`;
    } else if (
      (this.softWareTypeCode == 'TRM' ||
        this.softWareTypeCode == 'TEBS4' ||
        this.softWareTypeCode == 'EACS_EOL_Diagnostics' ||
        this.softWareTypeCode == 'TEBSG2') &&
      this.isUserLoggedIn
    ) {
      PayLoadString = `softwareLibrary/softwareRequest?softwareCode=${this.apiPayLoad.softwareCode}&company=${this.apiPayLoad.nodata
        }&firstName=${this.apiPayLoad.firstName}&lastName=${this.apiPayLoad.lastName}&postalCode=${this.apiPayLoad.postalCode
        }&country=${this.apiPayLoad.country}&emailID=${this.apiPayLoad.emailID}&isTrainingInfoRequired=${this.apiPayLoad.isTrainingInfoRequired
        }&softwareAndPi=${this.apiPayLoad.softwareAndPin}&softwareOnly=${this.apiPayLoad.softwareOnly}&pinRenewal=${this.apiPayLoad.softwareAndPi
        }&companyName=${this.apiPayLoad.companyName}&roleInIndustry=${this.apiPayLoad.roleInIndustry}&department=${this.apiPayLoad.department
        }&address=${this.apiPayLoad.address}&adress2=${this.apiPayLoad.adress2}&city=${this.apiPayLoad.city}&phone=${this.apiPayLoad.phone
        }&tradingPartner=${encodeURIComponent(this.apiPayLoad.tradingPartner)}&customTradingPartner=${this.apiPayLoad.nodata
        }&trainedPersonFirstName=${this.apiPayLoad.trainedPersonFirstName}&trainedPersonLastName=${this.apiPayLoad.trainedPersonLastName
        }&trainedPersonStillAtCompany=${this.apiPayLoad.trainedPersonStillAtCompany}&trainnerName=${this.apiPayLoad.trainnerName
        }&trainingDate=${this.apiPayLoad.trainingDate}&softwareTrainingDate=${this.apiPayLoad.softwareTrainingDate
        }&trainingPlace=${this.apiPayLoad.trainingPlace}&termsCheck=${this.apiPayLoad.termsCheck}&softwarePackageCode=${this.apiResponse.softwarePackageCode
        }&trainingInfoRequired=${this.apiPayLoad.trainingInfoRequired}&updateNotification=${this.apiPayLoad.updateNotification
        }&tradingPartnerFlag=${this.apiPayLoad?.tradingPartner ? true : ''}&softwareType=${this.apiPayLoad.softwareType
        }&captchaCode=${this.apiPayLoad.captchaCode}&Edit=${this.apiPayLoad.Edit}&softwareAndPin=${this.apiPayLoad.softwareAndPin
        }&eLearningCourseCompleted=${this.apiPayLoad.eLearningCourseCompleted}`;
      PayLoadString.replace(/%20/g, ' ');
    } else if (
      (this.softWareTypeCode == 'TRM' ||
        this.softWareTypeCode == 'TEBS4' ||
        this.softWareTypeCode == 'EACS_EOL_Diagnostics' ||
        this.softWareTypeCode == 'TEBSG2') &&
      !this.isUserLoggedIn
    ) {
      PayLoadString = `softwareLibrary/softwareRequest?softwareCode=${this.apiPayLoad.softwareCode}&company=${this.apiPayLoad.nodata
        }&firstName=${this.apiPayLoad.firstName}&lastName=${this.apiPayLoad.lastName}&postalCode=${this.apiPayLoad.postalCode
        }&country=${this.apiPayLoad.country}&emailID=${this.apiPayLoad.emailID}&isTrainingInfoRequired=${this.apiPayLoad.isTrainingInfoRequired
        }&softwareAndPi=${this.apiPayLoad.softwareAndPin}&softwareOnly=${this.apiPayLoad.softwareOnly}&pinRenewal=${this.apiPayLoad.softwareAndPi
        }&companyName=${this.apiPayLoad.companyName}&roleInIndustry=${this.apiPayLoad.roleInIndustry}&department=${this.apiPayLoad.department
        }&address=${this.apiPayLoad.address}&adress2=${this.apiPayLoad.adress2}&city=${this.apiPayLoad.city}&phone=${this.apiPayLoad.phone
        }&trainedPersonFirstName=${this.apiPayLoad.trainedPersonFirstName}&trainedPersonLastName=${this.apiPayLoad.trainedPersonLastName
        }&trainedPersonStillAtCompany=${this.apiPayLoad.trainedPersonStillAtCompany}&trainnerName=${this.apiPayLoad.trainnerName
        }&trainingDate=${this.apiPayLoad.trainingDate}&softwareTrainingDate=${this.apiPayLoad.softwareTrainingDate
        }&trainingPlace=${this.apiPayLoad.trainingPlace}&termsCheck=${this.apiPayLoad.termsCheck}&softwarePackageCode=${this.apiResponse.softwarePackageCode
        }&trainingInfoRequired=${this.apiPayLoad.trainingInfoRequired}&updateNotification=${this.apiPayLoad.updateNotification
        }&tradingPartner=${encodeURIComponent(this.apiPayLoad?.tradingPartner)}&tradingPartnerFlag=${this.apiPayLoad?.tradingPartner ? true : ''
        }&softwareType=${this.apiPayLoad.softwareType}&captchaCode=${this.apiPayLoad.captchaCode}&Edit=${this.apiPayLoad.Edit
        }&softwareAndPin=${this.apiPayLoad.softwareAndPin}&eLearningCourseCompleted=${this.apiPayLoad.eLearningCourseCompleted
        }`;
    } else {
      PayLoadString = `softwareLibrary/softwareRequest?softwareCode=${this.apiPayLoad.softwareCode}&company=${this.apiPayLoad.nodata}&firstName=${this.apiPayLoad.firstName}&lastName=${this.apiPayLoad.lastName}&postalCode=${this.apiPayLoad.postalCode}&country=${this.apiPayLoad.country}&emailID=${this.apiPayLoad.emailID}&isTrainingInfoRequired=${this.apiPayLoad.isTrainingInfoRequired}&softwareAndPi=${this.apiPayLoad.softwareAndPin}&softwareOnly=${this.apiPayLoad.softwareOnly}&pinRenewal=${this.apiPayLoad.softwareAndPi}&companyName=${this.apiPayLoad.companyName}&roleInIndustry=${this.apiPayLoad.roleInIndustry}&department=${this.apiPayLoad.department}&address=${this.apiPayLoad.address}&adress2=${this.apiPayLoad.adress2}&city=${this.apiPayLoad.city}&phone=${this.apiPayLoad.phone}&termsCheck=${this.apiPayLoad.termsCheck}&softwarePackageCode=${this.apiResponse.softwarePackageCode}&softwareType=${this.apiPayLoad.softwareType}&captchaCode=${this.apiPayLoad.captchaCode}`;
    }

    this.subscription?.add(this.service.postSoftWareForm(PayLoadString, this.fileData).subscribe((x: any) => {
      if (x.status.toLowerCase() == 'success') {
        this.router.navigateByUrl('/softwareConfirmationPage');
      }
    }));
  }

  //OpeningPopups and maintaining them
  openWebshop() {
    const ref = this.matdialog.open(WebshopPopupComponent, { minHeight: 390 });
    this.subscription?.add(ref.afterClosed().subscribe(() => {
      this.captchaSection.controls.webShopCheckBox.setValue(this.service.openWebShop);
    }));
  }

  openPrivacyPopup() {
    const ref = this.matdialog.open(PrivacyTermsPopUpComponent, { minHeight: 390 });
    this.subscription?.add(ref.afterClosed().subscribe(() => {
      this.captchaSection.controls.privacyTermsCheckBox.setValue(this.service.PrivacyTerms);
    }));
  }

  checkCaptcha(captchaResponse: any) {
    this.isRecaptchaDone = captchaResponse && captchaResponse.length > 0 ? true : false;
  }
  get captchaSectionFormControls() {
    return this.captchaSection.controls;
  }
  refreshCaptcha() {
    this.captchaService.fetchCaptcha();
  }
  inputValue(value) {
    if (this.captchaInput.length === 6) {
      this.captchaEmpty = false;
      this.submitCaptcha();
    } else if (this.captchaInput.length < 6) {
      this.captchaEmpty = false;
      this.captchaInvalid = false;
      this.captchaExpired = false;
      this.isRecaptchaDone = false;
    }
  }
  evaluateTradingPartnerVisibility(): void {
    const radio = this.topradioButtonState;

    const country = this.company.country.value;
    const role = this.company.role.value;
    const isSoftwareWithPinOrRenewal =
      radio === 'softwareandpin' || radio === 'softwarerenewal';

    const hasCountryAndIndustry = !!(country && role);

    const industry = this.getFilteredIndustry(this.softWareTypeCode, role);

    if (isSoftwareWithPinOrRenewal && hasCountryAndIndustry && industry) {
      this.canShowTradingPartner = true;
      this.company.tradingPartner.enable({ emitEvent: false });
    } else {
      this.canShowTradingPartner = false;
      this.company.tradingPartner.disable({ emitEvent: false });
      this.company.tradingPartner.reset(null, { emitEvent: false });
    }
  }
  submitCaptcha() {
    if (this.captchaInput) {
      this.subscription?.add(this.captchaService.submitCaptcha(this.challengeExpiry, this.captchaInput).subscribe({
        next: (response) => {
          this.isRecaptchaDone = true;
          this.captchaInvalid = false;
          this.captchaExpired = false;
          this.response = response.body;
          this.status = response.status;
          this.cdr.detectChanges();
        },
        error: (error) => {
          this.isRecaptchaDone = false;
          this.status = error.status;
          if (error.status == 403) {
            this.captchaInvalid = true;
            this.captchaExpired = false;
          } else if (error.status == 410) {
            this.captchaInvalid = false;
            this.captchaExpired = true;
          }
          if (isPlatformBrowser(this.platformId)) {
            window?.scrollTo(0, window?.scrollY);
          }
          event.preventDefault();
          this.cdr.detectChanges();
        },
      }));
    }
  }
  ngOnDestroy() {
    this.subscription.unsubscribe();
    this.service.PrivacyTerms = false;
    this.service.openWebShop = true;
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
    if (this.timeout) {
      clearTimeout(this.timeout);
    }
  }
}
